// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"view_appContainer__2jCRI"};